import { ParamDict, ParamDictToProps } from "@utils/params";
import { dedent } from "@utils/utils";
import { hslaToHsva, hsvaToHslaString } from "@utils/color";

//#region DatStyleparams
export const DatStyleParams = {
  // layout/size
  "size/width": { type: "int", value: 280, min: 1, max: 1000, step: 1 },
  "size/input/border": { type: "int", value: 3, min: 1, max: 20, step: 1 },
  "size/input/padding/vertical": { type: "int", value: 2, min: 1, max: 20, step: 1 },
  "size/input/padding/horizontal": { type: "int", value: 5, min: 1, max: 20, step: 1 },
  "size/borderLeft": { type: "int", value: 5, min: 1, max: 20, step: 1 },
  "size/nestMargin": { type: "int", value: 4, min: 1, max: 20, step: 1 },
  "size/numberHeight": { type: "int", value: 25, min: 1, max: 50, step: 1 },
  //
  "color/background": { type: "hsla", value: { h: 0, s: 0, l: 10, a: 1 } },
  "color/border": { type: "hsla", value: { h: 0, s: 0, l: 10, a: 1 } },
  "color/input": { type: "hsla", value: { h: 0, s: 0, l: 10, a: 1 } },
  "color/saveRow": { type: "hsla", value: { h: 40, s: 17, l: 82, a: 1 } },
  "color/button": { type: "hsla", value: { h: 340, s: 80, l: 51, a: 1 } },
  "color/boolean": { type: "hsla", value: { h: 287, s: 14, l: 47, a: 1 } },
  "color/number": { type: "hsla", value: { h: 199, s: 67, l: 51, a: 1 } },
  "color/string": { type: "hsla", value: { h: 147, s: 75, l: 47, a: 1 } },
  "color/select": { type: "hsla", value: { h: 48, s: 89, l: 64, a: 1 } },
  "color/presets": { type: "hsla", value: { h: 40, s: 17, l: 82, a: 1 } },
} satisfies ParamDict;
export type DatStyleParams = typeof DatStyleParams;
//opts
export const DatStyleOptsDefaults = ParamDictToProps(DatStyleParams);
export type DatStyleOpts = typeof DatStyleOptsDefaults;
//#endregion

export function DatStyleOptsToStyle(s: DatStyleOpts) {
  return dedent`
    :root {
      --ui-width: ${s["size/width"]}px;
      --input-padding: ${s["size/input/padding/vertical"]}px ${
    s["size/input/padding/horizontal"]
  }px;
      --input-border: ${s["size/input/border"]}px solid ${s["color/border"]};

      --border-left-size: ${s["size/borderLeft"]}px;
      --nest-margin: ${s["size/nestMargin"]}px;
      --number-height: ${s["size/numberHeight"]}px;

      --background-color: ${hsvaToHslaString(hslaToHsva(s["color/background"]))};
      --border-color: ${hsvaToHslaString(hslaToHsva(s["color/border"]))};
      --input-color: ${hsvaToHslaString(hslaToHsva(s["color/input"]))};
      --save-row-color: ${hsvaToHslaString(hslaToHsva(s["color/saveRow"]))};

      --boolean-color: ${hsvaToHslaString(hslaToHsva(s["color/boolean"]))};
      --number-color: ${hsvaToHslaString(hslaToHsva(s["color/number"]))};
      --string-color: ${hsvaToHslaString(hslaToHsva(s["color/string"]))};
      --button-color: ${hsvaToHslaString(hslaToHsva(s["color/button"]))};
      --select-color: ${hsvaToHslaString(hslaToHsva(s["color/select"]))};
      --presets-color: ${hsvaToHslaString(hslaToHsva(s["color/presets"]))};


      --folder-closed: #000
        url(data:image/gif;base64,R0lGODlhBQAFAJEAAP////Pz8////////yH5BAEAAAIALAAAAAAFAAUAAAIIlGIWqMCbWAEAOw==)
        6px 48% no-repeat;
      --folder-open: #000
        url(data:image/gif;base64,R0lGODlhBQAFAJEAAP////Pz8////////yH5BAEAAAIALAAAAAAFAAUAAAIIlI+hKgFxoCgAOw==)
        6px 48% no-repeat;
    }
  `;
}
